import { Injectable } from '@angular/core'

@Injectable()

export class DateHelper {


    addDays(date, days) {
        date.setDate(date.getUTCDate() + parseInt(days));
        return date
    };

    /**
     * Permite formatear una fecha usando un string con tokens
     * @param date (date|string)
     * @param format (string) Formato a darle a la fecha. Posibles tokens: %d (dd), %m (mm), %y (yyyy)
     */
    formattedDate(date, format: string): string {

        date = (date instanceof Date) ? date : new Date(date);
        date = date.toISOString();

        const arrayDate = date.split('T')[0].split('-');
        let returnDate = format.replace('%d', arrayDate[2]);
        returnDate = returnDate.replace('%m', arrayDate[1]);
        returnDate = returnDate.replace('%y', arrayDate[0]);

        return returnDate
    }

    diffBusinessDates(startDate: Date, endDate: Date): number {
        let count = 0;
        let curDate = startDate;
        while (curDate < endDate) {
            const dayOfWeek = curDate.getDay();
            const isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0);
            if (!isWeekend) { count++; }
            curDate = this.addDays(curDate, 1);
        }
        return count
    }

    addDaysNoRefence(date, days) {
        const returnDate: Date = new Date(date);

        returnDate.setDate(date.getUTCDate() + parseInt(days));
        return returnDate
    }
}
